<div
    class="flex items-center space-x-1 my-0.5 w-full transition-opacity"
    *ngFor="let bin of bins"
    [ngClass]="{ 'opacity-60': filteredBin != null && filteredBin !== bin }"
>
    <kb-star-rating [rating]="bin"></kb-star-rating>
    <div class="flex-1">
        <div class="bar bg-gray-100 border border-gray-200 h-3 w-full rounded-full">
            <div
                [ngClass]="{
                    'bg-yellow-400': filteredBin == null || (filteredBin != null && filteredBin === bin),
                    'bg-gray-400': filteredBin != null && filteredBin !== bin
                }"
                class="fill h-full rounded-full"
                [style.width.%]="getPercentage(bin)"
            ></div>
        </div>
    </div>
    <div class="text-sm w-8">
        {{ getFrequency(bin) }}
    </div>
    <button
        *ngIf="displayFilters"
        class="rounded px-2 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white disabled:opacity-50"
        [ngClass]="filteredBin === bin ? 'text-primary-800' : 'text-gray-400'"
        title="Filter reviews with this rating"
        (click)="toggleBinFilter(bin)"
        [disabled]="getFrequency(bin) === 0"
    >
        <fa-icon [icon]="eye"></fa-icon>
    </button>
</div>
